import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "./locales/ar.json";
import en from "./locales/en.json";

export const supportedLocales = ["ar", "en"] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

const storage = typeof window === "undefined" ? undefined : window.localStorage;
const storedLocale = storage?.getItem("jarasna-crm-locale");
const initialLocale: SupportedLocale = storedLocale === "en" ? "en" : "ar";

void i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en },
  },
  lng: initialLocale,
  fallbackLng: "ar",
  supportedLngs: supportedLocales,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export const applyLocaleToDocument = (locale: SupportedLocale) => {
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === "ar" ? "rtl" : "ltr";
  document.title = locale === "ar" ? ar.app.documentTitle : en.app.documentTitle;
  storage?.setItem("jarasna-crm-locale", locale);
};

applyLocaleToDocument(initialLocale);

export default i18n;
